const update_sql5 = [
    'drop table if exists t_friend;',
    'create table t_friend(uid PRIMARY KEY, lutime, lctime);',
    'drop table if exists t_app;',
    'create table t_app(' +
        'appkey PRIMARY KEY, main_appkey, plat, company, company_short,' +
        'company_desc, category, admin_uid, ruid, status,' +
        'ctime, lutime, lctime);',
    'drop table if exists t_task;',
    'create table t_task(' +
        'taskid PRIMARY KEY, type, data, status, errmsg,' +
        ' lutime, lctime);',
    'drop table if exists t_user',
    'create table t_user(' +
        ' uid PRIMARY KEY, name, name_py, name_pys, nick,' +
        ' nick_py, nick_pys, telno, email, employee,' +
        ' position, department, employee_id, appkey, main_appkey,' +
        ' avatar, status, remark, remark_py, remark_pys,' +
        ' lutime, lctime);',
    'drop table if exists t_group;',
    'create table t_group(' +
        ' tid PRIMARY KEY, uid, name, name_py, name_pys,' +
        ' admin_uids, cid, notice, tag, tagid,' +
        ' ctime, lutime, lctime);',
    'drop table if exists t_topic;',
    'create table t_topic(' +
        ' tid PRIMARY KEY, uid, name, cid, ctime,' +
        ' type, sid, hidemid, ord, lv_time,' +
        ' ls_mid, remark, mute, lutime, lctime)',
];

export default update_sql5;
